var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loginState === _vm.loginStates.AUTHORIZING)?[_c('h3',[_vm._v("Login läuft")]),_c('p',[_vm._v("Bitte warten...")])]:(_vm.loginState === _vm.loginStates.AUTHORIZED)?[_c('h3',[_vm._v("Login erfolgreich")])]:(_vm.loginState === _vm.loginStates.FAILED)?[_c('h3',[_vm._v("Login fehlgeschlagen")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }